(function () {
  'use strict';

  const STRINGS = {
    shippingProgress: 'Още {{ amount }}€ до безплатна доставка',
    shippingUnlocked: '🎉 Имаш безплатна доставка!',
    errorGeneric: 'Нещо се обърка, опитай отново',
    quantityDecrease: 'Намали количеството',
    quantityIncrease: 'Увеличи количеството',
    remove: 'Премахни',
    subtotal: 'Междинна сума',
    volumeDiscount: 'Отстъпка за количество',
    total: 'Общо',
  };

  const root = document.getElementById('TpCartDrawerRoot');
  if (!root) return;

  // Single source of truth: the free-shipping threshold lives on #TpCartDrawerRoot
  // (data-threshold, in subunits). The product-page shipping bar reads the same attribute.
  const FREE_SHIP_THRESHOLD_CENTS = parseInt(root.getAttribute('data-threshold'), 10) || 5000;

  const drawer = document.getElementById('TpCartDrawer');
  const backdrop = root.querySelector('.tp-cart-drawer__backdrop');

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function sizedImg(url, size) {
    if (!url) return '';
    const sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + size;
  }

  let lastFocused = null;

  /* -------- Render helpers -------- */

  function renderLine(item, index) {
    const hasCompare = item.original_line_price > item.final_line_price;
    const thumb = item.image
      ? `<img src="${escapeHtml(sizedImg(item.image, 128))}" srcset="${escapeHtml(sizedImg(item.image, 128))} 1x, ${escapeHtml(sizedImg(item.image, 256))} 2x" width="64" height="64" alt="${escapeHtml(item.product_title)}" loading="lazy">`
      : '';
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="tp-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>`
        : '';
    const priceInner = hasCompare
      ? `<span class="tp-cart-drawer__item-price-compare">${formatMoney(item.original_line_price)}</span>
         <span class="tp-cart-drawer__item-price-final">${formatMoney(item.final_line_price)}</span>`
      : `<span class="tp-cart-drawer__item-price-final">${formatMoney(item.final_line_price)}</span>`;

    return `
      <li class="tp-cart-drawer__item" data-line-item data-line="${index}" data-key="${escapeHtml(item.key)}">
        <a class="tp-cart-drawer__item-thumb" href="${escapeHtml(item.url)}" tabindex="-1" aria-hidden="true">${thumb}</a>
        <div class="tp-cart-drawer__item-info">
          <a class="tp-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${variant}
          <p class="tp-cart-drawer__item-price">${priceInner}</p>
        </div>
        <div class="tp-cart-drawer__item-actions">
          <div class="tp-cart-drawer__qty" role="group">
            <button type="button" class="tp-cart-drawer__qty-btn" data-qty-minus aria-label="${STRINGS.quantityDecrease}" ${
      item.quantity <= 1 ? 'disabled' : ''
    }>−</button>
            <span class="tp-cart-drawer__qty-value" data-qty-value>${item.quantity}</span>
            <button type="button" class="tp-cart-drawer__qty-btn" data-qty-plus aria-label="${STRINGS.quantityIncrease}">+</button>
          </div>
          <button type="button" class="tp-cart-drawer__remove" data-remove aria-label="${STRINGS.remove}">${STRINGS.remove}</button>
        </div>
      </li>`;
  }

  function summaryMarkup(cart) {
    const discountRow =
      cart.total_discount > 0
        ? `<div class="tp-cart-drawer__summary-row tp-cart-drawer__summary-row--discount">
             <span>${STRINGS.volumeDiscount}</span>
             <span>−${formatMoney(cart.total_discount)}</span>
           </div>`
        : '';
    return `
      <div class="tp-cart-drawer__summary-row">
        <span>${STRINGS.subtotal}</span>
        <span>${formatMoney(cart.items_subtotal_price)}</span>
      </div>
      ${discountRow}
      <div class="tp-cart-drawer__summary-row tp-cart-drawer__summary-row--total">
        <span>${STRINGS.total}</span>
        <span data-cart-subtotal>${formatMoney(cart.total_price)}</span>
      </div>`;
  }

  function updateShipping(totalPrice) {
    const shippingText = root.querySelector('[data-shipping-text]');
    const shippingFill = root.querySelector('[data-shipping-fill]');
    if (!shippingText || !shippingFill) return;

    const total = Number(totalPrice) || 0;
    const isUnlocked = total >= FREE_SHIP_THRESHOLD_CENTS;
    root.classList.toggle('is-unlocked', isUnlocked);

    if (isUnlocked) {
      shippingText.textContent = STRINGS.shippingUnlocked;
      shippingFill.style.width = '100%';
    } else {
      const remainingEur = Math.ceil((FREE_SHIP_THRESHOLD_CENTS - total) / 100);
      shippingText.textContent = STRINGS.shippingProgress.replace('{{ amount }}', remainingEur);
      const pct = Math.max(0, Math.min(100, (total / FREE_SHIP_THRESHOLD_CENTS) * 100));
      shippingFill.style.width = pct + '%';
    }
  }

  function updateHeaderBadge(count) {
    const cartLink = document.querySelector('a.header-cart, [data-cart-drawer-open]');
    if (!cartLink) return;
    let badge = cartLink.querySelector('.header-cart__badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header-cart__badge';
        badge.setAttribute('aria-hidden', 'true');
        cartLink.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function renderCart(cart) {
    // Keep the root's live total fresh so the product-page bar's MutationObserver fires.
    root.setAttribute('data-cart-total', cart.total_price);
    root.classList.toggle('is-empty', cart.item_count === 0);
    const itemsEl = root.querySelector('[data-cart-items]');
    const summaryEl = root.querySelector('[data-cart-summary]');
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map((item, i) => renderLine(item, i + 1)).join('');
    }
    // Swap the whole summary (subtotal + discount + total) so the volume-discount
    // row appears/disappears and re-totals as quantities change.
    if (summaryEl) {
      summaryEl.innerHTML = summaryMarkup(cart);
    }
    updateShipping(cart.total_price);
    updateHeaderBadge(cart.item_count);
  }

  function showError(msg) {
    const errorEl = root.querySelector('[data-cart-error]');
    if (!errorEl) return;
    errorEl.textContent = msg || STRINGS.errorGeneric;
    errorEl.hidden = false;
    setTimeout(() => {
      errorEl.hidden = true;
    }, 4000);
  }

  /* -------- AJAX ops -------- */

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function addToCart(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'add_failed');
    }
    const cart = await fetchCart();
    renderCart(cart);
    openDrawer();
  }

  async function changeQty(line, quantity) {
    const row = root.querySelector(`[data-line="${line}"]`);
    if (row) row.setAttribute('data-updating', '');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line, quantity }),
      });
      if (!res.ok) throw new Error('change_failed');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      if (row) row.removeAttribute('data-updating');
      showError();
    }
  }

  /* -------- Open / close -------- */

  function getFocusable() {
    if (!drawer) return [];
    return Array.from(
      drawer.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null);
  }

  function openDrawer() {
    if (root.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tp-cart-drawer-open');
    const closeBtn = root.querySelector('.tp-cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tp-cart-drawer-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  /* -------- Initial paint -------- */

  updateShipping(parseInt(root.getAttribute('data-cart-total'), 10) || 0);

  /* -------- Event wiring -------- */

  // Intercept ATC form submits (capture phase to beat Dawn's product-form).
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
      form.classList.add('is-loading');

      const fd = new FormData(form);
      addToCart(fd)
        .catch((err) => {
          showError(err && err.message && err.message !== 'add_failed' ? err.message : null);
        })
        .finally(() => {
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
          form.classList.remove('is-loading');
        });
    },
    true
  );

  // Open drawer from cart icon (capture phase).
  document.addEventListener(
    'click',
    function (e) {
      const trigger = e.target.closest('a.header-cart, [data-cart-drawer-open]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    },
    true
  );

  // Direct backdrop click → close (bound to element, in addition to the delegated handler below).
  if (backdrop) {
    backdrop.addEventListener('click', function (e) {
      e.stopPropagation();
      closeDrawer();
    });
  }

  // Delegated close-trigger handler (X button, continue-shopping, anything with data-cart-drawer-close).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
    }
  });

  // Delegated qty / remove clicks inside drawer.
  root.addEventListener('click', function (e) {
    const row = e.target.closest('[data-line]');
    if (!row) return;
    const line = parseInt(row.getAttribute('data-line'), 10);
    if (!line) return;

    if (e.target.closest('[data-qty-plus]')) {
      const current = parseInt(row.querySelector('[data-qty-value]').textContent, 10) || 1;
      changeQty(line, current + 1);
    } else if (e.target.closest('[data-qty-minus]')) {
      const current = parseInt(row.querySelector('[data-qty-value]').textContent, 10) || 1;
      if (current > 1) changeQty(line, current - 1);
    } else if (e.target.closest('[data-remove]')) {
      changeQty(line, 0);
    }
  });

  // Escape key + focus trap.
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      const focusable = getFocusable();
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
